<template>
   <v-dialog v-model="ccalistdialog" persistent max-width="550px">
      <v-card>
         <v-row no-gutters>
            <v-toolbar dense class="primary white--text">
               <v-toolbar-title>CCA Groups</v-toolbar-title>
               <v-spacer></v-spacer>
               <v-btn class="mx-2" @click.stop="cancelBtnClick">Cancel</v-btn>
               <v-btn class="mx-2" @click.stop="okBtnClick">OK</v-btn>
            </v-toolbar>
            <v-card>
               <v-card-title>
                  <v-text-field
                     v-model="ccagroup_search"
                     append-icon="mdi-magnify"
                     label="Search"
                     single-line
                     hide-details
                     class="pa-0"
                  ></v-text-field>
               </v-card-title>
               <v-data-table
                  class="px-3"
                  height="55vh"
                  dense
                  v-model="selectedgroup"
                  :headers="cca_headers"
                  :items="ccagroupdata"
                  @click:row="rowClick"
                  item-key="cca_id"
                  :search="ccagroup_search"
                  :single-select="singleSelect"
               >
               </v-data-table>
            </v-card>
         </v-row>
      </v-card>
   </v-dialog>
</template>

<script>
   export default {
      props: {
         dialogvisible: Boolean,
      },

      inject: ["ShowMessage"],

      data() {
         return {
            ccalistdialog: this.dialogvisible,
            selectedgroup: [],
            singleSelect: true,
            ccagroup_search: "",
            ccagroupdata: [],
            cca_headers: [
               {
                  text: "Name",
                  value: "cca_name",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Description",
                  value: "cca_description",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Term/Year",
                  value: "termyeartext",
                  class: this.$globalstore.table_headerclass,
               },
            ],
         };
      },
      watch: {
         dialogvisible: function(newval, oldval) {
            if (newval) {
               this.loadCCAList();
               this.selectedgroup = [];
               this.ccalistdialog = true;
            }
         },
      },

      methods: {
         rowClick(item, row) {
            row.select(!row.isSelected);
         },

         async loadCCAList() {
            await this.$http({
               url: "/cca/getccalist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.ccagroupdata = response.data.ccalist;
                  }
               }
            });
         },

         cancelBtnClick() {
            this.ccalistdialog = false;
            this.$emit("cancel-selection");
         },

         okBtnClick() {
            this.ccalistdialog = false;
            this.$emit("save-selection", this.selectedgroup[0]);
         },
      },
   };
</script>

<style>
   tr.v-data-table__selected {
      /* background: #7d92f5 !important; */
      background: #ffcdd2 !important;
   }
</style>
